import React from 'react';
import NavbarComponent from '../components/global/Navbar';

function RecreationPage()
{
    return (
        <section>
            <NavbarComponent />
        <div className='top'>
            <h1>Recreational Marijuana</h1>

            <h3>Illinois Bill 1438</h3>
            <p>Illinois legislature passes Bill 1438 which legalizes recreational marijuana. This bill allows recreational marijuana to be sold at licensed dispensaries in Illinois starting on January 1, 2020.</p>

            <h3>What does this mean?</h3>
            <p>Starting January 1, 2020, you will be able to purchase marijuana for recreational use at a certified Illinois dispensary. Earthmed will be selling both recreational and medical use cannabis at it’s Addison location. Earthmed will also be opening a second location in the Chicagoland area that will sell recreational marijuana.</p>

            <h3>What are the new provisions?</h3>
            <p>Bill 1438 allows residents age 21 and older to purchase cannabis at a licensed dispensary and legally possess 30 grams of cannabis, 5 grams of cannabis concentrate or 500 milligrams of THC contained in a cannabis-infused product. Nonresidents could possess 15 grams of cannabis.</p>

            <h3>How will it be taxed?</h3>
            <p>For consumers, the more THC is in the product, the higher the tax. As it stands there is a 10% sales tax on products containing less than 35% THC, a 25% sales tax on products containing over 35% THC, and a 20% sales tax on edible products. Medical cannabis is NOT subject to the same taxes.</p>

            <h3>When can I particpate</h3>
            <p>Hopefully January 1, 2020 but there are still a few state regulations that need to be finalized before moving forward. Keep this page bookmarked, we will update when the program starts.</p>
        </div>
        </section>
    )
}

export default RecreationPage;